import { SurveyAnswerTypeIdEnum } from '~modules/surveys/types/SurveyAnswerTypeIdEnum';

export type HappyScaleType = SurveyAnswerTypeIdEnum.HAPPY_INDEX_5 | SurveyAnswerTypeIdEnum.HAPPY_INDEX_10;

export class SurveyHelper {
  /**
   * Получает цвет фона для элемента шкалы счастья
   */
  static getHappyScaleBackgroundColor(index: number, isSelected: boolean, scaleType: HappyScaleType): string {
    if (!isSelected) return 'transparent';

    if (scaleType === SurveyAnswerTypeIdEnum.HAPPY_INDEX_10) {
      const colors = {
        1: '#D32F2F',
        2: '#F44336',
        3: '#E57373',
        4: '#EF9A9A',
        5: '#EF9A9A',
        6: '#FFB74D',
        7: '#FFB74D',
        8: '#FF9800',
        9: '#4CAF50',
        10: '#43A047',
      };
      return colors[index as keyof typeof colors];
    }

    if (scaleType === SurveyAnswerTypeIdEnum.HAPPY_INDEX_5) {
      const colors = {
        1: '#D32F2F',
        2: '#F44336',
        3: '#EF9A9A',
        4: '#FF9800',
        5: '#43A047',
      };
      return colors[index as keyof typeof colors];
    }

    return 'transparent';
  }
}
